import moment from "moment";

export const formatPayoutDateForInput = (value) => {
  if (!value) {
    return moment().format("DD-MM-YYYY");
  }

  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "";
};

export const formatPayoutDateForDisplay = (value) => {
  if (!value) {
    return "—";
  }

  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : "—";
};

export const parsePayoutDateInput = (value) => {
  const trimmedValue = String(value || "").trim();
  if (!trimmedValue) {
    return null;
  }

  const dutchFormat = moment(trimmedValue, "DD-MM-YYYY", true);
  if (dutchFormat.isValid()) {
    return dutchFormat.format("YYYY-MM-DD");
  }

  const isoFormat = moment(trimmedValue, "YYYY-MM-DD", true);
  if (isoFormat.isValid()) {
    return isoFormat.format("YYYY-MM-DD");
  }

  return null;
};

export const isPayoutDateOnOrAfterCreationDate = (payoutDateValue, creationDateValue) => {
  const payoutDate = moment(parsePayoutDateInput(payoutDateValue) || payoutDateValue);
  const creationDate = moment(creationDateValue);
  if (!payoutDate.isValid() || !creationDate.isValid()) {
    return false;
  }

  return payoutDate.startOf("day").isSameOrAfter(creationDate.startOf("day"));
};
